/**
 * Author：brand
 * Creation Time：2019-06-13 14:35
 * Email：brandhuang@qq.com
 */
import ax from '../../axios'

export function getTeamInfoAPI (params) {
  return ax({
    url: '/wlapi/entAccount/teamSetting',
    method: 'POST',
    params,
  })
}
export function saveTeamInfoAPI (params) {
  return ax({
    url: '/wlapi/entAccount/editCompany',
    method: 'POST',
    params,
  })
}

export function getServiceDetailAPI (params) {
  return ax({
    url: '/wlapi/entAccount/serDetail',
    method: 'POST',
    params,
  })
}


export function getContactsAPI (params) {
  return ax({
    url: '/wlapi/entAccount/contacts',
    method: 'GET',
    params,
  })
}
export function editContactsAPI (params) {
  return ax({
    url: '/wlapi/entAccount/editLinkMan',
    method: 'POST',
    params,
  })
}

export function getOperateRecordAPI (params) {
  return ax({
    url: '/wlapi/entAccount/optionRecord',
    method: 'POST',
    params,
  })
}

export function versionPayAPI (params) {
  return ax({
    url: '/wlapi/entAccount/pay',
    method: 'POST',
    params,
  })
}
export function versionWillPayAPI (params) {
  return ax({
    url: '/wlapi/entAccount/obligationPay',
    method: 'POST',
    params,
  })
}
export function versionCheckOrderAPI (params) {
  return ax({
    url: '/wlapi/entAccount/checkOrder',
    method: 'GET',
    params,
  })
}
export function delUpgradeInfoAPI (params) {
  return ax({
    url: '/wlapi/entAccount/delUgInfo',
    method: 'POST',
    params,
  })
}

export function sellerInfoStatusAPI (params) {
  return ax({
    url: '/wlapi/seller/sellerInfoStatus',
    method: 'POST',
    params,
  })
}